module.exports = __webpack_public_path__ + "static/6b4d4830-9c7d-43d2-b5d3-c73f739561b9-2cf657d43b13fe3a4618cb94bf0eaeb4.woff2";